import React from 'react';

import Form from 'react-bootstrap/Form';

const SwitchField = React.forwardRef(function (
  {
    className,
    controlId,
    type,
    disabled,
    required,
    label,
    value,
    onChange,
    reverse,
    ...props
  },
  ref
) {
  return (
    <Form.Group
      className={`w-100 align-middle ${className}`}
      controlId={controlId}>
      <Form.Check
        className='align-middle'
        type={type || 'switch'}
        disabled={disabled}
        checked={value === true}
        onChange={onChange}
        label={
          typeof label === 'string' ? (
            <span className='w-100 ms-3'>{label}</span>
          ) : (
            label
          )
        }
        ref={ref}
        reverse={reverse}
        {...props}
      />
    </Form.Group>
  );
});

export default SwitchField;
